import clsx from "clsx";
import React, { ReactNode } from "react";

interface RadioInputProps {
    value?: any;
    name?: string;
    checked: boolean;
    disabled?: boolean;
    children: ReactNode;
    className?: string;
    classNames?: { input: string };
    onChange: (e: any) => void;
}

export const RadioInput = ({
    value,
    checked,
    disabled = false,
    name,
    children,
    className,
    onChange,
    classNames,
}: RadioInputProps) => {
    return (
        <label className={clsx("flex w-fit items-center space-x-1", className)} data-testid="radio-input-label">
            <input
                checked={checked}
                disabled={disabled}
                value={value}
                type="radio"
                className={clsx(
                    "ring-0 focus:outline-none focus:ring-0",
                    classNames?.input,
                    disabled ? "!bg-gray-lighter" : "cursor-pointer",
                )}
                name={name}
                onChange={onChange}
            />
            <span>{children}</span>
        </label>
    );
};
